import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Card from "components/Card/Card.js";
import StarIcon from '@material-ui/icons/Star';
import styles from "assets/jss/material-kit-react/views/landingPageSections/testimonialStyle.js";
import CardBody from "components/Card/CardBody";
import CardFooter from "components/Card/CardFooter";

import GridItem from "components/Grid/GridItem";

const useStyles = makeStyles(styles);

export default function Testimonial(props) {
    const classes = useStyles();
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    return (
        <div>
            <Card plain>
            <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img
                    src={props.img}
                    alt={props.alt}
                    className={imageClasses}
                    style={{display: "initial", maxWidth: "25%"}}
                />
                </GridItem>
                <h4 className={classes.cardTitle}>
                    {props.name}
                </h4>
                <CardBody>
                    <p className={classes.description}>
                        {props.description}
                    </p>
                </CardBody>
                <CardFooter style={{display:"block", color:"#F43939"}}>
                    <StarIcon classes={classes.icon} /><StarIcon classes={classes.icon} /><StarIcon classes={classes.icon} /><StarIcon classes={classes.icon} /><StarIcon classes={classes.icon} />
                </CardFooter>
            </Card>
        </div>
    )
}
